// Measuring in the 3D view (docs/claude/rendering.md, *Measure in 3D*): what two
// points read — the distance between them and how far apart they stand along X,
// Y and Z. DOM-free.
import { type DimStyle } from '../shared/types';
import { formatDimension } from './dimFormat';
import { type Pt3 } from './handles';

/** What the second point reads from the first: the distance, and the signed
 *  gaps along X, Y and Z (whole mm), as the readout's two lines — each figure in
 *  the drawing's dimension style (`formatDimension`, as the handles' figures). */
export function measureReadout(a: Pt3, b: Pt3, style: DimStyle): { d: number; dx: number; dy: number; dz: number; lines: [string, string] } {
  const dx = Math.round(b.x - a.x), dy = Math.round(b.y - a.y), dz = Math.round(b.z - a.z);
  const d = Math.round(Math.hypot(b.x - a.x, b.y - a.y, b.z - a.z));
  const s = (v: number): string => `${v > 0 ? '+' : v < 0 ? '-' : ''}${formatDimension(Math.abs(v), style)}`;
  return { d, dx, dy, dz, lines: [formatDimension(d, style), `ΔX ${s(dx)} · ΔY ${s(dy)} · ΔZ ${s(dz)}`] };
}
